import React from "react";
import "./Core_team.css";
import { Link } from "react-router-dom";
import Common_title from "../../common_components/common-title/Common_title";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

const Core_team = ({ data }) => {
  return (
    <>
      <section className="Core_team_section">
        <div className="container">
          <Common_title
            title="Core Team"
            subtitle="Experts Who took an Initiative"
          />

          <div className="row mt-5 justify-content-center">
            {data?.map((val) => (
              <div className="col-md-4 col-sm-6 mb-4">
                <div className="team_member_card">
                  <div className="image_div">
                    <img
                      className="memberimg"
                      src={process.env.REACT_APP_IMG_URL + val?.image}
                      alt="Team Member 1"
                    />
                  </div>
                  <div className="overlay"></div>
                  <div className="member_info">
                    <h6 className="name">{val?.name}</h6>
                    <p className="position">{val?.designation}</p>
                    <div className="d-flex justify-content-center icondiv">
                      {val?.Team_Social_Links?.map((item) => {
                        return (
                          <a
                            href={item?.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div className="icon_holder">
                              <img
                                src={
                                  process.env.REACT_APP_IMG_URL +
                                  item?.Social_Link?.image
                                }
                                className="icon_img"
                              />
                            </div>
                          </a>
                        );
                      })}

                      {/* <Link>
                        <div className="icon_holder">
                          <FontAwesomeIcon
                            icon={faLinkedinIn}
                            className="fonticon"
                          />
                        </div>
                      </Link>

                      <Link>
                        <div className="icon_holder">
                          <FontAwesomeIcon
                            icon={faTwitter}
                            className="fonticon"
                          />
                        </div>
                      </Link> */}
                      {/* <Link><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/about-us/core-team/linkdin.png'} /></Link>
                                        <Link><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/about-us/core-team/twitter.png'} /></Link> */}
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* <div className='col-md-4 col-sm-6 mb-4'>
                            <div className='team_member_card'>
                                <div className='image_div'>
                                    <img className='memberimg' src={process.env.PUBLIC_URL + '/assets/images/about_us/core-team/person2.png'} alt="Team Member 1" />
                                </div>
                                <div className='overlay'></div>
                                <div className='member_info'>
                                    <h6 className='name'>Oshin Kawale</h6>
                                    <p className='position'>CEO</p>
                                    <div className='d-flex justify-content-center icondiv'>
                                        <Link>
                                            <div className='icon_holder'>
                                                <FontAwesomeIcon icon={faFacebookF} className='fonticon' />
                                            </div>
                                        </Link>

                                        <Link>
                                            <div className='icon_holder'>
                                                <FontAwesomeIcon icon={faLinkedinIn} className='fonticon' />
                                            </div>
                                        </Link>

                                        <Link>
                                            <div className='icon_holder'>
                                                <FontAwesomeIcon icon={faTwitter} className='fonticon' />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Core_team;
